import { useState, useCallback } from "react"

let _id = 0

export function useToast() {
    const [toasts, setToasts] = useState([])

    const addToast = useCallback((message, type = "error", duration = 4000) => {
        const id = ++_id
        setToasts(prev => [...prev, { id, message, type }])
        setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration)
    }, [])

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(t => t.id !== id))
    }, [])

    const toast = {
        error: (msg) => addToast(msg, "error"),
        success: (msg) => addToast(msg, "success"),
        info: (msg) => addToast(msg, "info"),
    }

    return { toasts, toast, removeToast }
}
